<app-add-form
  data-testid="purchase-request-add-form"
  #addForm
  [title]="'purchase_request.actions.new' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="saving()"
  [getFieldError]="getFieldError"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <!-- Actions Template for Items table -->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <span
        [attr.data-testid]="'purchase-request-add-action-delete-item-' + rowData.id"
        (click)="onTableAction({ action: 'deleteItem', data: rowData })"
        class="action-link action-delete cursor-pointer"
      >
        {{ "purchase_request.actions.delete" | translate }}
      </span>
    </div>
  </ng-template>
</app-add-form>

<!-- Item Dialog -->
<app-purchase-request-item-dialog
  data-testid="purchase-request-add-item-dialog"
  [(visible)]="showItemDialog"
  [initialData]="editingItem()"
  [editMode]="!!editingItem()"
  [existingItems]="itemsList()"
  (confirm)="onItemDialogConfirm($event)"
  (visibleChange)="showItemDialog.set($event)"
></app-purchase-request-item-dialog>

<!-- Toast Messages -->
<p-toast data-testid="purchase-request-add-toast"></p-toast>
